// - - - - - - - - - -
// #82 + #152 (2026-05-21) — Created/Verified + Open Repair predicate.
//
// Returns true iff a project should be treated as "unscheduled open work
// waiting for someone to act on it" — the pre-scheduled bucket displayed
// in the UnassignedProjects "Created/Verified" panel AND surfaced through
// `filteredProjectsList` even when `date_scheduled === ""`.
//
// Two clauses:
//   1. Created/Verified sub-statuses (#82, 2025) — `0 < sc < 3` covers
//      1.1-1.7, 2.1, etc. Per docs/status-codes.md these are pre-RTS
//      workflow states that haven't reached "Ready To Schedule" yet but
//      need to remain visible to install managers.
//   2. Open Repair Orders (#152, Brandon UAT 2026-05-21) — `sc === 30`
//      AND `classification === "Repair Order"`. Brandon's spec: "this
//      status needs to be added to that list in Scheduler so the Partial
//      Capacity Recommendations can recommend these repairs for open
//      available Scheduler spots." Leland's UX decision: same C/V section,
//      no new section. Without the classification gate this would also
//      sweep in status-30 docs of other classifications, which Brandon
//      explicitly warned against.
//
// Pure function — does NOT inspect `start`, `date_scheduled`, `installer`,
// or `location`. Callers compose those checks themselves (each call site
// has slightly different needs — `start === ""` for the optimizer's
// scheduleArray entries vs `date_scheduled === ""` for raw ActiveQueue
// docs in `filteredProjectsList`).
//
// Defensive against:
//   - missing/undefined `project` → false
//   - missing/undefined `statusCode` → parseFloat → NaN → both clauses false
//   - missing/undefined `classification` → clause 2 fails safely
export const isUnassignedOpenWork = (project) => {
  if (!project) return false;
  const code = parseFloat(project.statusCode);
  // Clause 1 — Created/Verified sub-statuses (#82)
  if (code > 0 && code < 3) return true;
  // Clause 2 — Open Repair Orders (#152)
  if (code === 30 && project.classification === "Repair Order") return true;
  return false;
};
